module.exports = __webpack_public_path__ + "src/app/assets/images/devday.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/images/devday.png
// module id = 627
// module chunks = 0